import { Button } from "antd";
import { memo, useState } from "react";
import { useFormContext } from "react-hook-form";
import CheckboxGroup from "src/components/utils/CheckboxGroup";

export const cleaningToolsOptions = [
  {
    label: "Mop or swiffer",
    value: "mop",
    icon: "🧽",
    disabled: false,
    checked: false,
  },
  {
    label: "Broom",
    value: "broom",
    icon: "🧹",
    disabled: false,
    checked: false,
  },
  {
    label: "Dust pan",
    value: "dust_pan",
    icon: "🗑️",
    disabled: false,
    checked: false,
  },
  {
    label: "Vacuum cleaner",
    value: "vacuum_cleaner",
    icon: "🔌",
    description:
      "If your vacuum cleaner is cordless, please ensure it's fully charged (100%) before your cleaner arrives.",
    disabled: false,
    checked: false,
  },
  {
    label: "Ladder or step stool",
    value: "ladder",
    icon: "🪜",
    disabled: false,
    checked: false,
  },
  {
    label: "None of these",
    value: "none",
    disabled: false,
    checked: false,
  },
  {
    label: "Others",
    value: "others",
    disabled: false,
    checked: false,
  },
];

function CleaningTools({ onSubmit }) {
  const {
    formState: { errors },
    register,
    setValue,
    control,
  } = useFormContext();

  const [cleaningTools, setCleaningTools] = useState(
    () => cleaningToolsOptions
  );

  const handleChange = (value: any) => {
    const updatedCleaningTools = [...cleaningTools];
    if (value.includes("none")) {
      updatedCleaningTools.forEach((tool) => {
        tool.disabled = tool.value !== "none";
        tool.checked = tool.value === "none";
      });
    } else {
      updatedCleaningTools.forEach((tool) => {
        tool.disabled = false;
        tool.checked = value.includes(tool.value);
      });
    }
    setCleaningTools([...updatedCleaningTools]);
    setValue(
      "cleaningTools",
      updatedCleaningTools
        .filter((tool) => tool.checked && !tool.disabled)
        .map((tool) => tool.value)
    );
  };

  const showOthers = cleaningTools.find(
    (tool) => tool.value === "others" && tool.checked && !tool.disabled
  );

  return (
    <div
      id="cleaning-tools-form"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        alignItems: "flex-start",
        justifyContent: "center",
        marginBottom: "2rem",
      }}
    >
      <p>
        This form only needs to be completed once! We'll save your preferences
        to make future bookings even easier! We can always bring our sanitzied
        tools, but it's always more sanitary to have your own.
      </p>
      <CheckboxGroup
        options={cleaningTools}
        onChange={handleChange}
        control={control}
        id="cleaningTools"
      />
      {showOthers && (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            marginTop: -16,
            gap: 0,
          }}
        >
          <textarea
            {...register("cleaningInstructions", {
              required: {
                value: true,
                message: "Please enter the name of the cleaning tool",
              },
            })}
            placeholder="Please enter the name of the cleaning tool"
            className="input"
            name="cleaningInstructions"
            rows={3}
            style={{
              borderRadius: 5,
              resize: "vertical",
              padding: "0.5rem 1rem",
              outlineColor: errors.cleaningInstructions
                ? "red"
                : "var(--blue-300)",
              border: "1px solid",
              borderColor: errors.cleaningInstructions
                ? "red !important"
                : "#d9d9d9",
            }}
          />
          {errors.cleaningInstructions && (
            <small style={{ color: "red", display: "block", marginBottom: 5 }}>
              {errors.cleaningInstructions.message}
            </small>
          )}
        </div>
      )}
      <Button
        form="instructions-form"
        onClick={onSubmit}
        type="primary"
        className="next-button w-full"
        value="Next"
      >
        Next
      </Button>
    </div>
  );
}

export default memo(CleaningTools);
